export const configRoute = {
    path: "/config",
    name: "游戏配置",
    meta: { title: "游戏配置", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "online_param",
            name: "在线参数管理",
            component: resolve => require(["@/components/config/onlineParam"], resolve),
            meta: { title: "在线参数管理" }
        },
        {
            path: "online_key",
            name: "复杂在线参数管理",
            component: resolve => require(["@/components/config/onlineKey"], resolve),
            meta: { title: "复杂在线参数管理" }
        },
        {
            path: "online_version",
            name: "版本管理",
            component: resolve =>
                require(["@/components/config/version"], resolve),
            meta: { title: "版本管理" }
        },
        {
            path: "adv_config",
            name: "广告配置管理",
            component: resolve =>
                require(["@/components/config/advConfig"], resolve),
            meta: { title: "广告配置管理" }
        },
        {
            path: "adv_strategy",
            name: "广告策略管理",
            component: resolve =>
                require(["@/components/config/advStrategy"], resolve),
            meta: { title: "广告策略管理" }
        },
        {
            path: "adv_strategy_app",
            name: "游戏策略配置",
            component: resolve =>
                require(["@/components/config/advStrategyApp"], resolve),
            meta: { title: "游戏策略配置" }
        },
        {
            path: "adv_launch",
            name: "广告投放数据",
            component: resolve =>
                require(["@/components/config/advLaunch"], resolve),
            meta: { title: "广告投放数据" }
        },
        {
            path: "app",
            name: "游戏管理",
            component: resolve => require(["@/components/config/app"], resolve),
            meta: { title: "游戏管理" }
        },
        {
            path: "app_chn",
            name: "游戏渠道管理",
            component: resolve =>
                require(["@/components/config/appChn"], resolve),
            meta: { title: "游戏渠道管理" }
        },
        {
            path: "app_loc",
            name: "游戏广告位管理",
            component: resolve =>
                require(["@/components/config/appLoc"], resolve),
            meta: { title: "游戏广告位管理" }
        },
        {
            path: "goods",
            name: "内购商品管理",
            component: resolve => require(["@/components/config/goods"], resolve),
            meta: { title: "内购商品管理" }
        },
        {
            path: "tenjin_app",
            name: "Tenjin应用管理",
            component: resolve => require(["@/components/config/tenjinApp"], resolve),
            meta: { title: "Tenjin应用管理" }
        },
        {
            path: "tenjin_ad_account",
            name: "Tenjin广告账户管理",
            component: resolve => require(["@/components/config/tenjinAdAccount"], resolve),
            meta: { title: "Tenjin广告账户管理" }
        },
        {
            path: "tenjin_campaign",
            name: "Tenjin广告系列管理",
            component: resolve => require(["@/components/config/tenjinCampaign"], resolve),
            meta: { title: "Tenjin广告系列管理" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/config.js